import React from "react"
import {Link} from 'gatsby'

const Masthead = () => {
  return(
    <header className="masthead text-center text-white">
      <div className="masthead-content">
        <div className="container">
          <h1 className="masthead-heading mb-0">X-CHANGE Meetup 2021</h1>
          <h2 className="masthead-subheading mb-0">by Schueleraustausch.net</h2>
          <p>
            Wir waren Live!
          </p>
          <Link to='/programm/' className="btn btn-primary btn-xl rounded-pill mt-5">
            Das war unser Programm!
          </Link>
        </div>
      </div>
      <div className="bg-circle-1 bg-circle"></div>
      <div className="bg-circle-2 bg-circle"></div>
      <div className="bg-circle-3 bg-circle"></div>
      <div className="bg-circle-4 bg-circle"></div>
    </header>
  )
}

export default Masthead
